import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="page contact-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <span className="page-badge">Contact</span>
            <h1>Get in Touch</h1>
            <p>Have a question or feedback? We'd love to hear from you</p>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              {submitted ? (
                <div className="success-message">
                  <div className="success-icon">✓</div>
                  <h3>Thank You!</h3>
                  <p>Your message has been received. We'll get back to you within 24-48 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">Your Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Smith"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a subject...</option>
                      <option value="general">General Enquiry</option>
                      <option value="casino">Casino Information</option>
                      <option value="partnership">Partnership Opportunity</option>
                      <option value="feedback">Website Feedback</option>
                      <option value="complaint">Complaint</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">Your Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      placeholder="How can we help you?"
                    ></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary btn-large">
                    Send Message
                  </button>
                </form>
              )}
            </div>

            <div className="contact-info-section">
              <div className="contact-card">
                <h3>Other Ways to Reach Us</h3>
                <div className="contact-methods">
                  <div className="contact-method">
                    <div className="method-icon">📧</div>
                    <div className="method-info">
                      <h4>Email</h4>
                      <p>contact@slotshubuk.com</p>
                      <span className="response-time">Response within 24-48 hours</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-card">
                <h3>Important Notice</h3>
                <p>
                  SlotsHub UK is an affiliate comparison website. We do not operate any casinos 
                  and cannot assist with individual casino accounts, bonuses, or withdrawals.
                </p>
                <p>
                  For issues with a specific casino, please contact that casino's customer 
                  support directly. Their contact details can be found on their website.
                </p>
              </div>

              <div className="contact-card highlight">
                <h3>Gambling Support</h3>
                <p>
                  If you need help with problem gambling, please contact these organisations 
                  directly – they offer free, confidential support:
                </p>
                <ul className="support-links">
                  <li>
                    <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer">
                      GambleAware
                    </a>
                  </li>
                  <li>
                    <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer">
                      GamCare
                    </a>
                    <span className="helpline">0808 8020 133</span>
                  </li>
                  <li>
                    <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer">
                      GAMSTOP Self-Exclusion
                    </a>
                  </li>
                </ul>
              </div>

              <div className="contact-card">
                <h3>Business Enquiries</h3>
                <p>
                  Interested in partnering with SlotsHub UK? We're always open to discussing 
                  collaboration opportunities with licensed UK operators.
                </p>
                <p className="business-email">
                  partnerships@slotshubuk.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
